export default __webpack_public_path__ + "static/media/register-icon.3a6b53a1.png";